export class PricePerMeterSync {
    public constructor() {
        this.initializePricePerMeterSync();
    }

    private initializePricePerMeterSync(): void {
        // Find all forms that contain both select boxes
        const forms = document.querySelectorAll('form');

        forms.forEach(form => {
            if ((form as HTMLElement).dataset.pricePerMeterSyncInitialized === '1') {
                return;
            }

            const minPricePerMeterSelect = form.querySelector(
                'select[name="minPricePerMeter"]',
            ) as HTMLSelectElement;
            const maxPricePerMeterSelect = form.querySelector(
                'select[name="maxPricePerMeter"]',
            ) as HTMLSelectElement;

            if (!minPricePerMeterSelect || !maxPricePerMeterSelect) {
                return;
            }

            (form as HTMLElement).dataset.pricePerMeterSyncInitialized = '1';

            minPricePerMeterSelect.addEventListener('change', () => {
                this.syncSelectBoxValue(minPricePerMeterSelect, maxPricePerMeterSelect);
            });

            maxPricePerMeterSelect.addEventListener('change', () => {
                this.syncSelectBoxValue(maxPricePerMeterSelect, minPricePerMeterSelect);
            });
        });
    }

    private syncSelectBoxValue(sourceSelect: HTMLSelectElement, targetSelect: HTMLSelectElement): void {
        const sourceValue = sourceSelect.value;

        // Find if the target select has the same option
        const targetOption = targetSelect.querySelector(`option[value="${sourceValue}"]`) as HTMLOptionElement;

        if (targetOption) {
            targetSelect.value = sourceValue;
        }
    }
}
